import React, { useState } from "react";
import axios from "axios";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  BarChart3,
  Store,
  X,
  CircleDollarSign,
  Gift,
  CreditCard,
  LogOut,
} from "lucide-react";
import { useAuth } from "../Context/AuthContext";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, getToken, logout } = useAuth();
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const openLogoutDialog = () => setIsLogoutOpen(true);
  const closeLogoutDialog = () => setIsLogoutOpen(false);
  const confirmLogout = async () => {
    try {
      const token = getToken?.();
      if (token) {
        await axios.post(
          "https://apisellhub.com/api//admin/logout",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }
    } catch (err) {
      // ignore API errors; proceed with local logout
      // console.error('Logout API error', err);
    } finally {
      logout();
      setIsLogoutOpen(false);
      if (onClose) onClose();
      navigate("/center/login");
    }
  };
  const navigation = [
    {
      name: "Dashboard",
      href: "/center/dashboard",
      icon: LayoutDashboard,
      current: location.pathname === "/center/dashboard",
    },
    {
      name: "Analytics",
      href: "/center/analytics",
      icon: BarChart3,
      current: location.pathname === "/center/analytics",
    },
    {
      name: "Seller",
      href: "/center/seller",
      icon: Store,
      current: location.pathname === "/center/seller",
    },
    {
      name: "Currency",
      href: "/center/currency",
      icon: CircleDollarSign,
      current: location.pathname === "/center/currency",
    },
    {
      name: "Pricing Plans",
      href: "/center/pricing-plans",
      icon: Gift,
      current: location.pathname === "/center/pricing-plans",
    },
    {
      name: "Payment Settings",
      href: "/center/payment-settings",
      icon: CreditCard,
      current: location.pathname === "/center/payment-settings",
    },
    // {
    //   name: "Charts",
    //   href: "/dashboard/charts",
    //   icon: BarChart3,
    //   current: location.pathname === "/dashboard/charts",
    // },


  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 bg-gray-800 border-r border-gray-700">
            {/* Logo */}
            <div className="flex items-center h-16 px-4 bg-gray-900">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center">
                    <img
                      src="/Images/logo.png" // <-- replace with your image path
                      alt="User Avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="ml-3">
                  <h1 className="text-white text-lg font-semibold">SellHub</h1>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex-1 flex flex-col overflow-y-auto">
              <nav className="flex-1 px-2 py-4 space-y-1">
                {navigation.map((item) => {
                  const Icon = item.icon;
                  return (
                    <NavLink
                      key={item.name}
                      to={item.href}
                      className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                        item.current
                          ? "bg-yellow-500 text-white-900 border-r-2 border-white-600"
                          : "text-gray-300 hover:bg-gray-700 hover:text-white"
                      }`}
                    >
                      <Icon
                        className={`mr-3 flex-shrink-0 h-5 w-5 ${
                          item.current
                            ? "text-white-600"
                            : "text-gray-400 group-hover:text-yellow-400"
                        }`}
                      />
                      {item.name}
                    </NavLink>
                  );
                })}
              </nav>

              {/* Bottom Section */}
              <div className="flex-shrink-0 flex border-t border-gray-700 p-4">
                <div className="flex items-center w-full">
                  {/* <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center">
                      <span className="text-gray-300 text-sm font-medium">
                        {" "}
                        {user?.name?.charAt(0).toUpperCase() || "U"}
                      </span>
                    </div>
                  </div> */}
                  {/* <div className="ml-3 min-w-0 flex-1">
                    <p className="text-sm font-medium text-gray-300 truncate">
                      {user?.name ?? ""}
                    </p>
                    <p className="text-sm text-gray-500 truncate">
                      {user?.email ?? ""}
                    </p>
                  </div> */}
                  <button
                    onClick={openLogoutDialog}
                    className="ml-3 inline-flex items-center px-3 py-2 text-sm font-medium text-red-400 hover:text-red-400 hover:bg-gray-700 rounded-md"
                    title="Logout"
                  >
                    <LogOut className="h-5 w-5 mr-2 text-red-500" />
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-800 transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Mobile Header */}
          <div className="flex items-center justify-between h-16 px-4 bg-gray-900">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center">
                  <img
                    src="/Images/logo.png" // <-- replace with your image path
                    alt="User Avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="ml-3">
                <h1 className="text-white text-lg font-semibold">SellHub</h1>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-300 hover:text-white p-1 rounded-md"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className="flex-1 flex flex-col overflow-y-auto">
            <nav className="flex-1 px-2 py-4 space-y-1">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    onClick={onClose}
                    className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                      item.current
                        ? "bg-purple-100 text-purple-900 border-r-2 border-purple-600"
                        : "text-gray-300 hover:bg-gray-700 hover:text-white"
                    }`}
                  >
                    <Icon
                      className={`mr-3 flex-shrink-0 h-5 w-5 ${
                        item.current
                          ? "text-purple-600"
                          : "text-gray-400 group-hover:text-purple-400"
                      }`}
                    />
                    {item.name}
                  </NavLink>
                );
              })}
            </nav>

            {/* Mobile Bottom Section */}
            <div className="flex-shrink-0 flex border-t border-gray-700 p-4">
              <div className="flex items-center w-full">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center">
                    <span className="text-gray-300 text-sm font-medium">U</span>
                  </div>
                </div>
                <div className="ml-3 min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-300 truncate">
                    {user?.name}
                  </p>
                  <p className="text-sm text-gray-500 truncate">
                    user@example.com
                  </p>
                </div>
                <button
                  onClick={openLogoutDialog}
                  className="ml-3 inline-flex items-center px-3 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700 rounded-md"
                  title="Logout"
                >
                  <LogOut className="h-5 w-5 mr-2" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLogoutOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-xl w-11/12 max-w-sm p-6">
            <h3 className="text-lg font-semibold text-white mb-2">
              Are you sure you want to logout?
            </h3>
            <p className="text-sm text-gray-400 mb-6">
              You will need to login again to access the dashboard.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={closeLogoutDialog}
                className="px-4 py-2 rounded-md text-sm font-medium text-gray-200 bg-gray-700 hover:bg-gray-600"
              >
                No
              </button>
              <button
                onClick={confirmLogout}
                className="px-4 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-500"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
